<template>
  <div
    class="flex flex-col items-center justify-center rounded-theme-md text-center"
    :class="[compact ? 'gap-2 px-4 py-4' : 'gap-4 px-6 py-10', containerClass]"
  >
    <!-- Custom icon slot or default box icon -->
    <slot name="icon">
      <div
        class="flex items-center justify-center rounded-full bg-theme-bg-subtle dark:bg-theme-surface-raised"
        :class="compact ? 'h-9 w-9' : 'h-12 w-12'"
      >
        <svg
          class="text-theme-text-muted"
          :class="compact ? 'h-5 w-5' : 'h-6 w-6'"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
          />
        </svg>
      </div>
    </slot>

    <!-- Text -->
    <div>
      <h3
        class="font-semibold text-theme-text"
        :class="compact ? 'text-sm' : 'text-base'"
      >
        {{ title || $t('general_no_data') }}
      </h3>
      <p
        v-if="message"
        class="mt-1 text-theme-text-secondary"
        :class="compact ? 'text-xs' : 'text-sm'"
      >
        {{ message }}
      </p>
    </div>

    <!-- Optional CTA slot -->
    <slot />
  </div>
</template>

<script>
/**
 * AppEmptyState — generic empty / no-data state component.
 *
 * Usage (basic):
 *   <app-empty-state :title="t('general_no_results')" />
 *
 * Usage (compact, inside a card body):
 *   <app-empty-state compact :title="t('ui.section_empty')" />
 *
 * Usage (with custom icon and action):
 *   <app-empty-state :title="t('dashboards.none')" :message="t('dashboards.create_first')">
 *     <template #icon><Icon :path="mdiViewDashboard" size="24" /></template>
 *     <app-button @click="create">{{ t('create') }}</app-button>
 *   </app-empty-state>
 */
export default {
  name: 'AppEmptyState',

  props: {
    /** Bold heading */
    title: { type: String, default: '' },
    /** Descriptive sub-text */
    message: { type: String, default: '' },
    /** Tighter padding + smaller icon, for use inline inside a card body */
    compact: { type: Boolean, default: false },
    /** Extra classes on the outer container */
    containerClass: { type: [String, Array, Object], default: '' },
  },
};
</script>
